import React, { Component, useEffect } from 'react'
import PropTypes from 'prop-types'
import SendFile from '../assets/Clip.png'
import styled, { css } from "styled-components";

export class FileUpload extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        const { onChange, disabled } = this.props

        return (
            <div>
                <input                  
                  type="file"
                  id="document-upload"
                  onChange={(e) => {
                    e.preventDefault()  
                    onChange(e.currentTarget.files)
                  }}
                  style={{display: 'none'}}
                  disabled={disabled}
                />
                <UploadIcon
                    image={SendFile}
                    htmlFor="document-upload"
                >
                </UploadIcon>
            </div>
        )
    }

}

const UploadIcon = styled.label`
    flex: none;
    display: inline-flex;
    vertical-align: top;
    align-items: flex-end;
    justify-content: flex-end;
    width: 30px;
    height: 30px;
    background-color: transparent;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 3px;
    margin-left: 5px;
    ${props =>
    props.image &&
    css`
        background-image: url(${props.image});
    `};
    ${props =>
    props.isSmall &&
    css`
        width: 90%;
        height: 90%;
    `};
    ${props =>
    props.isActive &&
    css`
        opacity: 1;
        filter: alpha(opacity=100);
    `};
    ${props =>
    !props.isActive &&
    css`
        opacity: 0.5;
        filter: alpha(opacity=50);
    `};
`;